import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AppContext from "../AppContext";
import { BASE_CHAT_URL, BASE_URL, userRole } from "./../constant";
import "../index.css";
import { Link } from "react-router-dom";
import AppLogo from "../AppLogo";
import axios from "axios";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LangChanger";
import ChatBox, { ChatFrame } from "react-chat-plugin";
import DynamicChart from "./chatbotConfig/DynamicChart";
import "react-chat-elements/dist/main.css";
import { ChatList, MessageBox, Input, Button } from "react-chat-elements";
import CustomChatComponent from "./chatbotConfig/CustomChatComponent";
const CustomAvatar = () => {
  return (
    <img
      src="ai_icon.svg"
      alt="Avatar"
      style={{ width: "40px", height: "40px", borderRadius: "50%" }}
    />
  );
};
function Layout({ children }) {
  const navigate = useNavigate();
  const {
    authCtx,
    setPlayBackMode,
    navigation,
    setNavigation,
    setApiLoaded,
    darkMode,
    setDarkMode,
  } = useContext(AppContext);
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [navbarOpen, setNavbarOpen] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false);

  const isDashboard =
    location.pathname === "/dashboard" || location.pathname === "/";
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  const [attr, setAttr] = useState({
    showChatbox: false,
    showIcon: true,
    showTypingIndicator: false,
    messages: [],
  });
  const { t } = useTranslation();

  const handleClickIcon = () => {
    // toggle showChatbox and showIcon
    setAttr({
      ...attr,
      showChatbox: !attr.showChatbox,
      showIcon: !attr.showIcon,
    });
  };

  // const simulateApiCall = async (message) => {
  //   await new Promise((resolve) => setTimeout(resolve, 1000));

  //   if (
  //     message.toLowerCase().includes("mileage") ||
  //     message.toLowerCase().includes("fuel consumption")
  //   ) {
  //     return {
  //       type: "cards",
  //       cards: [
  //         {
  //           title: "Total Mileage",
  //           value: "1,925 km",
  //           label: "This week",
  //           icon: "activity",
  //         },
  //         {
  //           title: "Fuel Consumption",
  //           value: "319 L",
  //           label: "This week",
  //           icon: "fuel",
  //         },
  //         {
  //           title: "Efficiency",
  //           value: "6.03 km/L",
  //           label: "Average this week",
  //           icon: "trending-up",
  //         },
  //       ],
  //       explanation:
  //         "This week, our fleet has covered a total distance of 1,925 km while consuming 319 L of fuel. The average efficiency stands at 6.03 km/L, which is a 5% improvement from last week.",
  //     };
  //   } else if (message.toLowerCase().includes("chart")) {
  //     return {
  //       type: "chart",
  //       data: [
  //         { date: new Date(2024, 7, 18), consumption: 45, mileage: 250 },
  //         { date: new Date(2024, 7, 19), consumption: 42, mileage: 280 },
  //         { date: new Date(2024, 7, 20), consumption: 48, mileage: 270 },
  //         { date: new Date(2024, 7, 21), consumption: 44, mileage: 290 },
  //         { date: new Date(2024, 7, 22), consumption: 50, mileage: 300 },
  //         { date: new Date(2024, 7, 23), consumption: 47, mileage: 260 },
  //         { date: new Date(2024, 7, 24), consumption: 43, mileage: 275 },
  //       ],
  //       config: [
  //         {
  //           yName: "consumption",
  //           name: "Consumption (L)",
  //           type: "Spline",
  //           color: "#56b6f7",
  //         },
  //         {
  //           yName: "mileage",
  //           name: "Mileage (km)",
  //           type: "Spline",
  //           color: "#82ca9d",
  //         },
  //       ],
  //       explanation:
  //         "This chart shows the daily fuel consumption and mileage for the past week. We can observe that mileage peaked on August 22nd at 300 km, while fuel consumption was highest on August 20th at 48 L. There seems to be a slight positive correlation between daily mileage and fuel consumption.",
  //     };
  //   } else if (message.toLowerCase().includes("top 3 vehicles")) {
  //     return {
  //       type: "table",
  //       headers: [
  //         "Vehicle ID",
  //         "Type",
  //         "Avg. Efficiency (km/L)",
  //         "Total Distance (km)",
  //         "Total Fuel Consumed (L)",
  //       ],
  //       data: [
  //         {
  //           id: "V001",
  //           type: "Hybrid Truck",
  //           efficiency: "8.5",
  //           distance: "1,200",
  //           fuelConsumed: "141",
  //         },
  //         {
  //           id: "V002",
  //           type: "Electric Van",
  //           efficiency: "N/A",
  //           distance: "950",
  //           fuelConsumed: "0",
  //         },
  //         {
  //           id: "V003",
  //           type: "Diesel Truck",
  //           efficiency: "6.2",
  //           distance: "1,500",
  //           fuelConsumed: "242",
  //         },
  //       ],
  //       explanation:
  //         "This table compares the fuel efficiency of our top 3 vehicles. The Electric Van (V002) has the best environmental impact with zero fuel consumption, while the Hybrid Truck (V001) shows the best fuel efficiency among fuel-consuming vehicles.",
  //     };
  //   } else {
  //     return {
  //       type: "text",
  //       text: "I'm sorry, I don't have specific information for that query. Can you please ask about mileage, fuel consumption, or request a chart?",
  //     };
  //   }
  // };
  const onClickSettings = () => {
    // const dashboardRoute = navigation.find((x) => x.name === "Dashboard");
    // onNavigate(dashboardRoute);
    navigate(`/settings`);
    setIsOpen(false);
  };
  const onClickLogo = () => {
    setPlayBackMode(100);
    // const dashboardRoute = navigation.find((x) => x.name === "Dashboard");
    // onNavigate(dashboardRoute);
    navigate(`home`);
  };

  const onLogoutClick = () => {
    authCtx.logout();
    setApiLoaded(false);
    navigate("/");
    setIsOpen(false);
  };

  const onNavigate = (d) => {
    if (d.href && !d.soon) {
      navigate(d.href);
      setNavigation((pre) =>
        pre.map((x) =>
          x.name === d.name ? { ...x, current: true } : { ...x, current: false }
        )
      );
    }
  };

  const loadCompanies = async () => {
    const res = await axios.get(`${BASE_URL}/api/CompanyMaster`);
    if (res.status === 200) {
      setCompanies(res.data);
    }
  };

  useEffect(() => {
    if (location.pathname.startsWith("/analytics")) {
      setNavigation((pre) =>
        pre.map((x) =>
          x.name === "Analytics"
            ? { ...x, current: true }
            : { ...x, current: false }
        )
      );
    } else if (location.pathname.startsWith("/health")) {
      setNavigation((pre) =>
        pre.map((x) =>
          x.name === "Health"
            ? { ...x, current: true }
            : { ...x, current: false }
        )
      );
    } else if (location.pathname.startsWith("/home")) {
      setNavigation((pre) =>
        pre.map((x) =>
          x.name === "Home" ? { ...x, current: true } : { ...x, current: false }
        )
      );
    } else {
      setNavigation((pre) =>
        pre.map((x) =>
          x.name === "Dashboard"
            ? { ...x, current: true }
            : { ...x, current: false }
        )
      );
    }
  }, [location]);

  useEffect(() => {
    loadCompanies();
  }, []);

  return (
    <div className="h-screen w-full dark:bg-neutral-900 bg-zinc-300 mb-20 overflow-hidden">
      <div className="md:px-7 sm:px-4 px-2 flex justify-between items-center w-full md:h-14 h-12">
        <div className="flex gap-3 items-center">
          <button
            type="button"
            className="md:h-9 h-7  pr-1 flex items-center cursor-pointer"
            onClick={onClickLogo}
          >
            <Link to="home" className="flex md:gap-3 gap-1 items-center">
              <AppLogo />
            </Link>
          </button>
        </div>
        <div className="flex md:pl-7 items-center sm:pl-4 pl-2 gap-2 dark:text-neutral-700 text-neutral-700">
          <div className="text-xs">
            {authCtx.profile.companyId ? (
              <div className="flex flex-col font-medium   md:mr-7 sm:mr-4 mr-2 border-r-2 h-full w-fit dark:text-neutral-300 dark:border-neutral-100 text-neutral-600 border-neutral-700">
                <label className=" md:text-sm sm:text-xs text-xxs px-3 py-1 w-full">
                  {
                    companies.find((x) => x.id === authCtx.profile.companyId)
                      ?.name
                  }
                </label>
              </div>
            ) : (
              <label className="text-orange-400 md:text-sm sm:text-xs text-xxs">
                Company Not Assigned
              </label>
            )}
          </div>
          {/* )} */}
          <div className=" hidden md:flex">
            {navigation.map((x, index) => (
              <button
                onClick={() => onNavigate(x)}
                key={index}
                className={`${
                  x.current
                    ? "dark:text-white dark:border-white text-black border-b-4 border-black"
                    : "text-neutral-500"
                } h-full flex items-center relative gap-1 my-auto md:px-3 md:py-3 px-2 py-1 md:text-sm sm:text-xs text-xxs font-medium `}
              >
                {t(`navigations.${x.name}`)}
                {x.soon ? (
                  <sup className="font-bold bg-gradient-to-r from-red-600 to-orange-600 h-3 inline-block text-transparent bg-clip-text pt-1">
                    Soon
                  </sup>
                ) : null}
                {x?.badAssetCount ? (
                  x.badAssetCount > 0 ? (
                    <div className="h-4 w-4 flex justify-center items-center text-xs text-white absolute top-0 right-0 rounded-full bg-red-600">
                      {x?.badAssetCount}
                    </div>
                  ) : (
                    <div className="h-4 w-4 flex justify-center items-center text-xs text-white absolute top-0 right-0 rounded-full bg-green-600">
                      {x?.badAssetCount}
                    </div>
                  )
                ) : null}
              </button>
            ))}
          </div>
          <div className="flex md:hidden relative dropdown dropdown-end">
            <button
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
              tabIndex="0"
              className="inline-flex btn bg-inherit border-none hover:bg-inherit  md:px-4 sm:px-2 px-0 relative items-center md:p-3 p-1 text-sm font-medium text-center"
            >
              <svg
                class="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 17 14"
              >
                <path
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M1 1h15M1 7h15M1 13h15"
                />
              </svg>
            </button>
            {navbarOpen && (
              <div
                tabindex="0"
                className="dropdown-content border-neutral-500 menu w-fit z-40 dark:bg-gray-800 bg-neutral-900 text-white rounded shadow border mt-10"
              >
                {navigation.map((x, index) => (
                  <button
                    onClick={() => onNavigate(x)}
                    key={index}
                    className={`${
                      x.current
                        ? "text-white border-b-4 border-white"
                        : "text-neutral-500"
                    } h-full flex items-center relative gap-1 my-auto md:px-3 md:py-3 px-5 py-1 md:text-sm sm:text-xs text-xxs font-medium `}
                  >
                    {t(`navigations.${x.name}`)}
                    {x.soon ? (
                      <sup className="font-bold bg-gradient-to-r from-red-600 to-orange-600 h-3 inline-block text-transparent bg-clip-text pt-1">
                        Soon
                      </sup>
                    ) : null}
                    {x?.badAssetCount ? (
                      x.badAssetCount > 0 ? (
                        <div className="h-4 w-4 flex justify-center items-center text-xs text-white absolute top-0 right-2 rounded-full bg-red-600">
                          {x?.badAssetCount}
                        </div>
                      ) : (
                        <div className="h-4 w-4 flex justify-center items-center text-xs text-white absolute top-0 right-2 rounded-full bg-green-600">
                          {x?.badAssetCount}
                        </div>
                      )
                    ) : null}
                  </button>
                ))}
              </div>
            )}
          </div>
          <div className=" hidden md:flex pl-3 px-1">
            <button
              type="button"
              className="inline-flex relative items-center text-sm font-medium text-center"
            >
              <img
                src="notification-icon.svg"
                alt="notifications"
                className="md:h-7 md:w-7 h-3 w-3"
              />
              <span className="sr-only">Notifications</span>
            </button>
          </div>
          <div className="px-1">
            <LanguageSwitcher />
          </div>
          <button
            type="button"
            class=" flex items-center px-1 text-gray-600 font-medium transition-all ease-in-out duration-150"
            onClick={() => {
              setDarkMode(!darkMode);
              if (!darkMode) {
                document.documentElement.classList.add("dark");
                // localStorage.setItem("dark-mode", true);
              } else {
                document.documentElement.classList.remove("dark");
                // localStorage.setItem("dark-mode", false);
              }
            }}
          >
            {darkMode ? (
              <img
                src="lightIcon.svg"
                className="md:h-7 md:w-7 h-3 w-3 transition-all ease-in-out duration-150"
                alt="darkIcon"
              />
            ) : (
              <img
                src="darkIcon.svg"
                className="md:h-7 md:w-7 h-3 w-3 transition-all ease-in-out duration-150"
                alt="lightIcon"
              />
            )}
          </button>
          <div className="relative px-1 dropdown dropdown-end">
            <div className="relative">
              <button onClick={() => setIsOpen(!isOpen)}>
                <div
                  className="btn bg-inherit border-none hover:bg-inherit md:px-2 sm:px-1 px-0"
                  tabIndex="0"
                >
                  <img
                    src="profile_icon.svg"
                    alt="propic"
                    className="md:h-7 md:w-7 h-3 w-3"
                  />
                </div>
              </button>
              {isOpen && (
                <div
                  tabindex="0"
                  className="dropdown-content dropDownProfile menu w-fit pt-4 z-40 dark:bg-gray-800 bg-neutral-900 text-white rounded-lg shadow border dark:border-transparent mt-5"
                >
                  <ul className="dark:text-white space-y-3">
                    <div className="flex px-5 gap-3 justify-start">
                      <div className="flex w-12 justify-center items-center">
                        <img
                          src="profile_icon.svg"
                          alt="propic"
                          className="h-12 w-12"
                        />
                      </div>
                      <div className="flex flex-col w-fit gap-1">
                        <label className="font-bold text-sm truncate">
                          {authCtx.profile?.name}
                        </label>
                        <label className=" font-normal text-xxs">
                          {authCtx.profile?.emailId}
                        </label>
                        <label className="font-semibold text-xs">
                          {authCtx.profile?.username}
                        </label>
                        <label className="font-semibold text-xs role-gradient">
                          {
                            userRole.find((u) => u.id === authCtx.profile?.role)
                              ?.name
                          }
                        </label>
                      </div>
                    </div>
                    <div className="flex border-t border-stone-500 justify-start font-medium">
                      {authCtx.profile?.role !== 300 && (
                        <button
                          type="button"
                          className="inline-flex px-5 py-2 border-r border-stone-500 h-full w-1/2 relative items-center text-sm font-medium text-center"
                          onClick={onClickSettings}
                        >
                          <Link
                            to="/settings"
                            className="inline-flex items-center text-sm font-medium text-center"
                          >
                            <div className="mr-3">
                              <img
                                src="settings-icon.svg"
                                alt="settings"
                                className=""
                              />
                            </div>
                            <div className="text-xs">
                              {t("userProfile.settings")}
                            </div>
                          </Link>
                        </button>
                      )}
                      <div
                        className={`${
                          authCtx.profile?.role === 300
                            ? " w-full justify-end px-3"
                            : " w-1/2 justify-end px-5"
                        } flex py-2 font-medium`}
                      >
                        <button
                          type="button"
                          onClick={onLogoutClick}
                          className="flex gap-2 cursor-pointer items-center text-orange-600 transform transition-colors duration-200 border-r-4 border-transparent justify-center"
                        >
                          <label className="text-xs">
                            {t("userProfile.logout")}
                          </label>
                          <div className="mr-3">
                            <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9 1H11.6667C12.0203 1 12.3594 1.14048 12.6095 1.39052C12.8595 1.64057 13 1.97971 13 2.33333V11.6667C13 12.0203 12.8595 12.3594 12.6095 12.6095C12.3594 12.8595 12.0203 13 11.6667 13H9"
                                stroke="#F45208"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M5.66699 10.3332L9.00033 6.99984L5.66699 3.6665"
                                stroke="#F45208"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M9 7H1"
                                stroke="#F45208"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                        </button>
                      </div>
                    </div>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className={`h-[93vh] w-screen overflow-x-hidden ${
          darkMode ? "darkChatContainer" : "lightChatContainer"
        }`}
      >
        <div
          className={`z-[9999] shadow-xl ${
            isExpanded
              ? "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-opacity-90 backdrop-blur-md h-screen w-screen"
              : "fixed bottom-[100px] right-[40px]"
          } bg-[#2c2c2c] rounded-[15px] overflow-hidden flex flex-col`}
          style={{
            display: attr.showChatbox ? "flex" : "none",
          }}
        >
          <CustomChatComponent
            isExpanded={isExpanded}
            setIsExpanded={setIsExpanded}
          />
        </div>
        {!isDashboard && (
          <div
            className="bottom-10 right-10 fixed z-[9999]"
            onClick={handleClickIcon}
          >
            <img
              style={{
                // background: "white",
                borderRadius: "100%",
                background:
                  "linear-gradient(to right,#2d3748, #1a202c,  #000000)",
                boxShadow: " 1px 4px 6px #1a202c",
                border: "none",
                fontSize: "14px",
                cursor: "pointer",
                height: "45px",
                width: "45px",
              }}
              src="ai_icon.svg"
              className="mx-auto top-0 h-12 w-12 cursor-pointer"
              alt="Chat Icon"
            />
          </div>
        )}
        {children}
      </div>
    </div>
  );
}

export default Layout;
